/**
 * Fixed tracks so a stack of separate boxes still reads as columns at `lg` and up.
 * Below that the row stacks into a card and these widths fall away.
 */
export const SLOT_COLUMNS = {
  document: 'min-w-0 flex-1',
  status: 'lg:w-28 lg:shrink-0',
  expires: 'lg:w-28 lg:shrink-0',
  actions: 'lg:w-44 lg:shrink-0',
}

export const SLOT_ACCEPT = '.pdf,.xlsx,.xls,.csv,.tsv,.txt,.docx,.doc,.png,.jpg,.jpeg,.gif,.webp'
export const SLOT_MAX_MB = 10
